import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
  } from '@angular/common/http';
  import { Observable } from 'rxjs';
  import { Injectable } from '@angular/core';
  import { environment } from '../../environments/environment';
  
  @Injectable()
  export class AddHeaderInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      // Clone the request to add the new header
      let clonedRequest = req.clone();
      if(req.url.indexOf("cruzotec.com") > -1 || req.url.indexOf("localhost") > -1){ 
        const clientName = environment.clientName ? environment.clientName : '';
      clonedRequest   = req.clone({ headers: req.headers.append('x-app-name', clientName ? clientName : '') });
      }
      // Pass the cloned request instead of the original request to the next handle
      return next.handle(clonedRequest);
    }
  }